<template>
    <div class="tab-pane fade" id="RealtimeMap" role="tabpanel" aria-labelledby="realtimemap-tab">
        <div class="h3 mb-3 text-white">Se busser i sanntid</div>
        <div class="form-group">
            <a href="https://sanntid.vkt.no" target="_blank" class="btn btn-primary" title="Gå til kart" aria-label="Gå til kart">Gå til kart</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'RealtimeMap'
    }
</script>